import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const ASPIRATOR_TYPES_BASE_URL = '/v1/settings/centers/aspirator-types'
const COMERCIAL_DATA_BASE_URL = '/v1/settings/centers/comercial-data'
const GAS_TYPES_BASE_URL = '/v1/settings/centers/gas-types'
const HEATER_TYPES_BASE_URL = '/v1/settings/centers/heater-types'
const OTHER_TECNICS_TYPES_BASE_URL = '/v1/settings/centers/other-tecnics-types'
const PLATTEN_TYPES_BASE_URL = '/v1/settings/centers/platten-types'
const SERVICE_TYPES_BASE_URL = '/v1/settings/centers/service-types'
const SOAP_TYPES_BASE_URL = '/v1/settings/centers/soap-types'
const TRACK_TYPES_BASE_URL = '/v1/settings/centers/track-types'
const WASHING_TYPES_BASE_URL = '/v1/settings/centers/washing-types'
const MAINTENANCE_TYPES_BASE_URL = '/v1/settings/centers/maintenance-types'

const endpointsCenterSettings = {
  aspiratorTypes: {
    CREATE: ASPIRATOR_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${ASPIRATOR_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${ASPIRATOR_TYPES_BASE_URL}/${id}`,
  },

  comercialData: {
    CREATE: COMERCIAL_DATA_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${COMERCIAL_DATA_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${COMERCIAL_DATA_BASE_URL}/${id}`,
  },

  gasTypes: {
    CREATE: GAS_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${GAS_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${GAS_TYPES_BASE_URL}/${id}`,
  },

  heaterTypes: {
    CREATE: HEATER_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${HEATER_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${HEATER_TYPES_BASE_URL}/${id}`,
  },

  otherTecnicsTypes: {
    CREATE: OTHER_TECNICS_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${OTHER_TECNICS_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${OTHER_TECNICS_TYPES_BASE_URL}/${id}`,
  },

  plattenTypes: {
    CREATE: PLATTEN_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${PLATTEN_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${PLATTEN_TYPES_BASE_URL}/${id}`,
  },

  serviceTypes: {
    CREATE: SERVICE_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${SERVICE_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${SERVICE_TYPES_BASE_URL}/${id}`,
  },

  soapTypes: {
    CREATE: SOAP_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${SOAP_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${SOAP_TYPES_BASE_URL}/${id}`,
  },

  trackTypes: {
    CREATE: TRACK_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${TRACK_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${TRACK_TYPES_BASE_URL}/${id}`,
  },

  washingTypes: {
    CREATE: WASHING_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${WASHING_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${WASHING_TYPES_BASE_URL}/${id}`,
  },

  maintenanceTypes: {
    CREATE: MAINTENANCE_TYPES_BASE_URL,
    LOAD: (filter, sort, limit, skip) =>
      `${MAINTENANCE_TYPES_BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    LOAD_BY_ID: (id) => `${MAINTENANCE_TYPES_BASE_URL}/${id}`,
  },
}

export default endpointsCenterSettings
